const sidebar = document.querySelector('.sidebar');
const showSidebarBtnsArr = Array.from(document.querySelectorAll('.sidebar-toggler'));
const closeSidebarBtnsArr = Array.from(document.querySelectorAll('.sidebar__close'));

function toggleSidebar(el) {
  function show(target) {
    const sidebarSection = el.querySelector(target);

    el.classList.add('sidebar_active');
    sidebarSection.classList.add('sidebar__section_visible');
    document.body.style.overflow = 'hidden';
  }

  function hide(target) {
    el.classList.remove('sidebar_active');
    target.classList.remove('sidebar__section_visible');
    document.body.style = null;
  }

  function close(e) {
    // eslint-disable-next-line eqeqeq
    if (e.target == e.currentTarget) {
      hide(el.querySelector('.sidebar__section_visible'));
    }
  }

  return {
    show,
    hide,
    close,
  };
}

if (sidebar) {
  const sidebarPanel = toggleSidebar(sidebar);

  showSidebarBtnsArr.forEach((showSidebarBtnsArrEl) => {
    showSidebarBtnsArrEl.addEventListener('click', (e) => {
      sidebarPanel.show(e.target.getAttribute('data-target'));
    });
  });

  closeSidebarBtnsArr.forEach((closeSidebarBtnsArrEl) => {
    closeSidebarBtnsArrEl.addEventListener('click', (e) => {
      sidebarPanel.hide(e.target.closest('.sidebar__section'));
    });
  });

  sidebar.addEventListener('click', (e) => {
    sidebarPanel.close(e);
  });
}
